import React, { ReactElement } from "react";
import "./shimmer.scss";

export interface ShimmerProps {
    className?: string;
    loading?: boolean;
    children?: ReactElement | ReactElement[];
}

const Shimmer: React.FunctionComponent<ShimmerProps> = ({ children, className = "", loading }: ShimmerProps): ReactElement => {

    if (!loading) {
        return (<>{children}</>);
    }

    return (
        <div className={`shimmer ${className}`} data-locator='shimmer'>
            {children && React.Children.map(children, (child: ReactElement) => {
                return React.cloneElement(child, { "aria-disabled": true, "aria-label": "loading" });
            })}
        </div>
    );
};

export default Shimmer;
